import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'luci-tree',
  templateUrl: './luci-tree.component.html',
  styleUrls: ['./luci-tree.component.scss']
})
export class LuciTreeComponent implements OnInit {

  constructor() { }
  @Input() items = [];
  @Input() icons: any;
  @Input() classNames = '';
  @Input() isParent =  false;
  @Input() selectedItem = '';
  @Input() disableLeafNode = false;
  @Input() isIcons = false;

  @Output() updateSelection = new EventEmitter();
  @Output() updateSelectedItem = new EventEmitter();

  ngOnInit() {
  }

  selectListItem($event: MouseEvent, item: any) {
    if (item.children && item.children.length === 0 && !item.isFolder) {
      this.updateItem({});
    } else {
      this.updateItem(item);
    }
  }

  expand(item) {
    if (!item.isDisable) {
      item.expanded = true;
    }
  }

  collapse(item) {
    if (!item.isDisable) {
      item.expanded = false;
      item.children.forEach((child) => {
        child.expanded = false;
      });
    }
  }

  updateItem(event) {
    if (this.isParent) {
      if (!event.isDisable) {
        this.selectedItem = event.name;
      }
      this.updateSelectedItem.emit(event.isDisable ?  {} : event);
    } else {
      this.updateSelection.emit(event);
    }
  }

  getIcon(icon) {
    return `assets/icons/luci.svg#${icon}`;
  }

}
